import AppStateBase from "./analytics/appStateBase";
import CookieManager from "./utilities/cookiemanager";
import { getDeviceClasses } from "./utilities/utils";
import "./utilities/date";
import eventBus from "./utilities/eventBus";
import ACTIONS from "./utilities/eventBusActions";

import { ROTATE } from "./analytics/analyticsevents";

import Resizer from "./../touch/common/components/resizer";
import { resetReaderSession } from "./subscriptionmanagement/subscriptionUtilities";

export default class AppState extends AppStateBase {
  _isLoggedIn = false;
  _downloadToken = null;
  isTablet = false;
  isDesktop = true;
  _isIOS = null;
  _isWindows = null;
  inFullScreenMode = false;
  _isDoublePage = true;
  _readerSessionCookie = null;
  _newDownloaderFallbackMode = false;

  _authenticatorAuthorisationController = null;

  cdnAssetsDownloader = null;

  _currentPage = null;
  _totalPages = 0;
  _contentPackageId = null;
  _publicationId = null;
  _articleLightBoxDisplayed = false;

  _authorized = false;

  _contentid = null;

  _sharingUrl = null;
  _username = null;

  socialSharingNumberOfArticles = 0;
  _socialSharingReset = null;
  viewedArticles = [];

  nextgenSharingArticle = null;

  classNames = null;
  _timeBasedUnlimitedAccessEnabled = false;

  portrait = window.innerWidth < window.innerHeight;
  width = window.innerWidth;
  height = window.innerHeight;
  _preferredViewer = CookieManager.getCookie(
    CookieManager.cookieKeys.PREFERRED_VIEWER
  );
  _isFreePublication = false;
  isReplica = false;
  constructor(analyticsManager, options = {}) {
    super(analyticsManager);
    this.isReader = options.isReader;
    this._options = options;
    this._eventListeners();
    this.initDevice();
    this._checkSocialSharing();
    this._checkNextgenSharingArticle();
  }

  initResizer() {
    this.resizer = new Resizer(
      document.querySelector("#main-app"),
      this.classNames
    );
    this.initResizerListeners();
  }
  initResizerListeners() {
    this.resizer.on("resizer:heightChanged", () => {
      this.trigger("appState:heightChanged");
      this.heightChanged();
    });
    this.resizer.on("resizer:rotated", () => {
      if (!this.isDesktop) this.triggerEvent(ROTATE);
    });
  }

  nextgenLoaded() {
    this.trigger("nextgen:loaded");
  }

  heightChanged() {
    //analytics
    this.checkHeightChanged();
  }

  setMobileDoublePage(toggle, defaultValue) {
    if (toggle) {
      const cookieValue = CookieManager.getCookie(
        CookieManager.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY
      );
      if (cookieValue) {
        this._isDoublePage = cookieValue === "true";
      } else {
        this._isDoublePage = defaultValue;
        CookieManager.createCookie(
          CookieManager.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY,
          this._isDoublePage
        );
      }
    } else {
      this._isDoublePage = defaultValue;
    }
  }

  setDesktopDoublePage(toggle, defaultValue) {
    if (toggle) {
      const cookieValue = CookieManager.getCookie(
        CookieManager.cookieKeys.DESKTOP_DOUBLEPAGE
      );
      if (cookieValue) {
        this._isDoublePage = cookieValue === "true";
      } else {
        this._isDoublePage = defaultValue;
        CookieManager.createCookie(
          CookieManager.cookieKeys.DESKTOP_DOUBLEPAGE,
          this._isDoublePage
        );
      }
      if (
        (this._isDoublePage &&
          document.body.classList.contains("singlePage")) ||
        this._preferredViewer == "nextgen"
      ) {
        document.body.classList.remove("singlePage");
      } else {
        document.body.classList.add("singlePage");
      }
    } else {
      this._isDoublePage = defaultValue;
      if (document.body.classList.contains("singlePage"))
        document.body.classList.remove("singlePage");
    }
  }

  initDoublePage() {
    if (this.isDesktop) {
      this.setDesktopDoublePage(
        this._options.replicaReadingModeToggle.desktop,
        this._options.replicaReadingModeDefault.desktop
      );
    } else if (this.isTablet) {
      this.setMobileDoublePage(
        this._options.replicaReadingModeToggle.tablet,
        this._options.replicaReadingModeDefault.tablet
      );
    } else {
      this.setMobileDoublePage(
        this._options.replicaReadingModeToggle.phone,
        this._options.replicaReadingModeDefault.phone
      );
    }
  }

  initDevice() {
    //desktop or touch
    this.classNames = getDeviceClasses();
    this.classNames.forEach((className) => {
      document.body.classList.add(className);
    });
    this.isTablet = this.classNames.indexOf("tablet") >= 0;
    this.isDesktop = !(this.classNames.indexOf("mobile") >= 0);

    this.initDoublePage();
  }

  _eventListeners() {
    if (!this.isDesktop || !this._options.replicaReadingModeToggle.desktop) {
      return;
    }
    eventBus.on(ACTIONS.PUBLICATION_SWITCHED, ({ isNextgen }) => {
      if (isNextgen) {
        document.body.classList.remove("singlePage");
      } else {
        document.body.classList.add("singlePage");
      }
    });
  }

  _checkNextgenSharingArticle() {
    const regexToMatch = /(?:article|content)\/(.*)/g;
    const found = window.location.hash.match(regexToMatch);
    if (found && found[0]) {
      const parts = found[0].split("/");
      if (parts && parts.length > 1 && parts[1]) {
        this.nextgenSharingArticle = parseInt(parts[1], 10);
      }
    }
    return null;
  }

  _checkSocialSharing() {
    if (
      this._options.socialSharingHash &&
      window.location.search.indexOf(`&${this._options.socialSharingHash}`) !==
        -1
    ) {
      this.socialSharing = true;
      window.history.replaceState(
        null,
        null,
        window.location.href.replace(`&${this._options.socialSharingHash}`, "")
      );
    } else if (
      this._options.socialSharingHash &&
      window.location.search.indexOf(`${this._options.socialSharingHash}&`) !==
        -1
    ) {
      this.socialSharing = true;
      window.history.replaceState(
        null,
        null,
        window.location.href.replace(`${this._options.socialSharingHash}&`, "")
      );
    } else if (
      this._options.socialSharingHash &&
      window.location.search.indexOf(`${this._options.socialSharingHash}`) !==
        -1
    ) {
      this.socialSharing = true;
      window.history.replaceState(
        null,
        null,
        window.location.href.replace(`${this._options.socialSharingHash}`, "")
      );
    }
  }

  _inClassNames(array) {
    for (let i = 0; i < array.length; i++) {
      if (this.classNames.indexOf(array[i]) < 0) {
        return false;
      }
    }
    return true;
  }

  _oneInClassNames(array) {
    for (let i = 0; i < array.length; i++) {
      if (this._inClassNames(array[i])) {
        return true;
      }
    }
    return false;
  }

  initUsePdf(usePdf) {
    if (this.isDesktop) {
      if (
        usePdf.usePdfDesktopNot &&
        this._oneInClassNames(usePdf.usePdfDesktopNot)
      ) {
        return;
      }
      if (usePdf.usePdfDesktop === true) {
        this.usePdf = true;
        return;
      }
      if (usePdf.usePdfDesktop && this._oneInClassNames(usePdf.usePdfDesktop)) {
        this.usePdf = true;
        return;
      }
    } else if (this.isTablet) {
      if (
        usePdf.usePdfTabletNot &&
        this._oneInClassNames(usePdf.usePdfTabletNot)
      ) {
        return;
      }
      if (usePdf.usePdfTablet === true) {
        this.usePdf = true;
        return;
      }
      if (usePdf.usePdfTablet && this._oneInClassNames(usePdf.usePdfTablet)) {
        this.usePdf = true;
        return;
      }
    } else {
      if (
        usePdf.usePdfPhoneNot &&
        this._oneInClassNames(usePdf.usePdfPhoneNot)
      ) {
        return;
      }
      if (usePdf.usePdfPhone === true) {
        this.usePdf = true;
        return;
      }
      if (usePdf.usePdfPhone && this._oneInClassNames(usePdf.usePdfPhone)) {
        this.usePdf = true;
        return;
      }
    }
  }

  checkHeightChanged() {
    this.portrait = window.innerWidth < window.innerHeight;
    if (!this.articleLightBoxDisplayed) {
      this.trigger("appState:heightChangedALBClosed");
    }
  }

  changeCurrentPage(
    index,
    doNotTriggerEvents = false,
    socialSharingAllowed = false,
    originIsReader = false
  ) {
    const newIndex = parseInt(index, 10);
    const promise = new Promise((resolve, reject) => {
      if (doNotTriggerEvents) {
        this._currentPage = newIndex;
        resolve();
      }
      if (index === this._currentPage) {
        resolve(true);
      } else if (
        this.socialSharing &&
        !socialSharingAllowed &&
        this.articleLightBoxDisplayed
      ) {
        this.trigger(
          "appState:currentpagechanged",
          this._currentPage,
          originIsReader
        );
        this.trigger("appState:pageChangeNotAuthorised");
        reject(false);
      } else {
        this.canGoToPage(newIndex)
          .then(() => {
            this._currentPage = newIndex;
            this.trigger(
              "appState:currentpagechanged",
              newIndex,
              originIsReader
            );
            resolve(true);
          })
          .catch(() => {
            this.trigger("appState:pageChangeNotAuthorised");
            this.trigger(
              "appState:currentpagechanged",
              this._currentPage,
              originIsReader
            );
            //TODO show dialog
            reject(false);
          });
      }
    });
    return promise;
  }

  isNextgenSharing() {
    return (
      !this.isReplica &&
      this.socialSharing &&
      (this.nextgenSharingArticle !== null ||
        this._options.allowNextgenPageSharing)
    );
  }

  /**
   * Check if user may go to that page (authorized, possible, ...)
   */
  canGoToPage(index) {
    //TODO: authorized?
    const goToPagePromise = new Promise((resolve, reject) => {
      const promiseData = {};
      promiseData.reject = reject;
      promiseData.resolve = resolve;
      const publicationData = {
        contentPackageId: this._contentPackageId,
        publicationId: this._publicationId,
        pageId: index,
      };
      this._authenticatorAuthorisationController
        .authorizePage(publicationData)
        .then(() => {
          promiseData.resolve(true);
        })
        .catch((error) => {
          promiseData.reject(error);
        });
    });
    return goToPagePromise;
  }

  canGoToArticle(pageId, contentItemId) {
    const contentId = this.isNextgenSharing()
      ? `${this._contentPackageId}_${pageId}`
      : contentItemId;
    if (
      this._authenticatorAuthorisationController.authorizeArticle(
        this._contentPackageId,
        this._publicationId,
        pageId,
        contentId
      )
    ) {
      return true;
    } else {
      this.trigger("appState:authorizeArticleFailed");
      return false;
    }
  }

  getUserSubscriptionType() {
    if (!this.isLoggedIn) {
      return "ANONYMOUS";
    }
    if (this.userSubscriptionType === "metered") {
      return this.userSubscriptionType.toUpperCase();
    }
    return "SUBSCRIPTION";
  }

  isReaderSessionCookieValid() {
    const cookie = CookieManager.getCookie(
      CookieManager.cookieKeys.READER_SESSION
    );
    if (cookie) {
      const contentPackageId = JSON.parse(cookie).cpId;
      if (contentPackageId === this.contentPackageId) {
        return true;
      }
    }
    return false;
  }

  saveReaderSessionCookie() {
    this._readerSessionCookie = CookieManager.getCookie(
      CookieManager.cookieKeys.READER_SESSION
    );
  }

  replaceReaderSessionCookie() {
    if (this._readerSessionCookie) {
      resetReaderSession(CookieManager, this._readerSessionCookie);
    }
  }

  //getters

  get newDownloaderFallbackMode() {
    return this._newDownloaderFallbackMode;
  }

  set newDownloaderFallbackMode(newDownloaderFallbackMode) {
    this._newDownloaderFallbackMode = newDownloaderFallbackMode;
  }

  get currentPage() {
    return this._currentPage;
  }

  get totalPages() {
    return this._totalPages;
  }
  set totalPages(pages) {
    this._totalPages = pages;
  }

  get socialSharingReset() {
    return this._socialSharingReset;
  }
  set socialSharingReset(socialSharingReset) {
    if (!socialSharingReset) {
      return;
    }
    const lowerCase = socialSharingReset.toLowerCase();
    if (lowerCase == "session") {
      this._socialSharingReset = lowerCase;
    } else if (lowerCase == "contentpackage") {
      this._socialSharingReset = lowerCase;
    } else if (lowerCase == "week") {
      this._socialSharingReset = lowerCase;
      if (
        typeof Storage !== "undefined" &&
        this.socialSharingNumberOfArticles > 0 &&
        this.socialSharing
      ) {
        const now = new Date();
        var item = JSON.parse(localStorage.getItem("contentItemsWeek"));
        if (
          !item ||
          item["year"] < now.getWeekYear() ||
          item["week"] < now.getWeek()
        ) {
          item = {};
          item["year"] = now.getWeekYear();
          item["week"] = now.getWeek();
          item["items"] = {};
          localStorage.setItem("contentItemsWeek", JSON.stringify(item));
        }
      }
    }
  }

  get authorized() {
    return this._authorized;
  }
  set authorized(authorized) {
    this._authorized = authorized;
  }

  get contentPackageId() {
    return this._contentPackageId;
  }
  set contentPackageId(contentPackageId) {
    this._contentPackageId = contentPackageId;
  }

  get publicationId() {
    return this._publicationId;
  }
  set publicationId(publicationId) {
    this._publicationId = publicationId;
    this.trigger("appState:publicationChanged", publicationId);
  }

  get subscriptionId() {
    const cookie = CookieManager.getCookie(CookieManager.cookieKeys.LOGIN);
    if (cookie) {
      return JSON.parse(CookieManager.getCookie(CookieManager.cookieKeys.LOGIN))
        .subsId;
    }
  }

  get username() {
    if (this._username === null) {
      const cookie = CookieManager.getCookie(CookieManager.cookieKeys.LOGIN);
      if (cookie) {
        return JSON.parse(
          CookieManager.getCookie(CookieManager.cookieKeys.LOGIN)
        ).userName;
      }
    } else {
      return this._username;
    }
  }

  get downloadId() {
    const cookie = CookieManager.getCookie(
      CookieManager.cookieKeys.READER_SESSION
    );
    if (cookie) {
      if (JSON.parse(cookie).downloadId) {
        return JSON.parse(cookie).downloadId;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  }

  get orderId() {
    const cookie = CookieManager.getCookie(
      CookieManager.cookieKeys.READER_SESSION
    );
    if (cookie) {
      return JSON.parse(cookie).orderId || 0;
    } else {
      return 0;
    }
  }

  get articleLightBoxDisplayed() {
    return this._articleLightBoxDisplayed;
  }

  get timeBasedUnlimitedAccessEnabled() {
    return this._timeBasedUnlimitedAccessEnabled;
  }
  set articleLightBoxDisplayed(articleLightBoxDisplayed) {
    this._articleLightBoxDisplayed = articleLightBoxDisplayed;
    if (!articleLightBoxDisplayed) {
      this.albClosed();
      if (this.lastHeightNoALB !== this.resizer.oldAppHeight) {
        this.trigger("appState:heightChangedALBClosed");
      }
    } else {
      this.lastHeightNoALB = this.resizer.oldAppHeight;
    }
  }

  set contentid(value) {
    if (value && this._contentid !== value) {
      /*
      The webapp reloads for the second time when the NG is ready to be opened, the articleViewed saved is "contentPackageId_pageId".
      When the NG is reloaded with a sharing url we need to ensure that the article saved is compared with the correct contentId.
      */
      if (this.canGoToArticle(this.currentPage, value)) {
        this._contentid = value;
        this.trigger("appState:contentIdChanged");
      } else {
        if (!this._contentid) {
          this._contentid = value;
        }
        this.trigger("appState:authorizeArticleFailed");
      }
    } else if (!value && this._contentid) {
      this._contentid = null;
      this.trigger("appState:contentIdChanged");
    }
  }

  get contentid() {
    return this._contentid;
  }

  get isLoggedIn() {
    return this._isLoggedIn;
  }

  set logedIn(login) {
    this._isLoggedIn = login;
    this.trigger("appState:authenticationstatuschanged");
  }

  get downloadToken() {
    return this._downloadToken;
  }

  set downloadToken(downloadToken) {
    this._downloadToken = downloadToken;
    this.trigger("appState:downloadtokenchanged");
  }

  get isIOS() {
    if (this._isIOS == null) {
      if (document.querySelector("body").classList.contains("iOS")) {
        this._isIOS = true;
      } else {
        this._isIOS = false;
      }
    }
    return this._isIOS;
  }

  get isAndroid() {
    if (this._isAndroid == null) {
      if (document.querySelector("body").classList.contains("AndroidOS")) {
        this._isAndroid = true;
      } else {
        this._isAndroid = false;
      }
    }
    return this._isAndroid;
  }

  get isWindows() {
    if (this._isWindows == null) {
      if (document.querySelector("body").classList.contains("windows")) {
        this._isWindows = true;
      } else {
        this._isWindows = false;
      }
    }
    return this._isWindows;
  }

  get preferredViewer() {
    if (!this._preferredViewer) {
      const cookieValue = CookieManager.getCookie(
        CookieManager.cookieKeys.PREFERRED_VIEWER
      );

      if (cookieValue) {
        this._preferredViewer = cookieValue;
      } else {
        CookieManager.createCookie(
          CookieManager.cookieKeys.PREFERRED_VIEWER,
          this._options.defaultPreferredViewer
        );
        this._preferredViewer = this._options.defaultPreferredViewer;
      }
    }

    return this._preferredViewer;
  }

  set preferredViewer(preferredViewer) {
    const previousValue = this._preferredViewer;
    this._preferredViewer = preferredViewer;
    CookieManager.createCookie(
      CookieManager.cookieKeys.PREFERRED_VIEWER,
      preferredViewer
    );

    // only trigger event when preferred viewer really changed value
    if (
      previousValue !== undefined &&
      previousValue !== this._preferredViewer
    ) {
      this.trigger("preferredViewer:changed", this._preferredViewer);
    }
  }

  set timeBasedUnlimitedAccessEnabled(timeBasedUnlimitedAccessEnabled) {
    this._timeBasedUnlimitedAccessEnabled =
      timeBasedUnlimitedAccessEnabled === true;
  }

  get isDoublePage() {
    if (this.isDesktop) {
      if (this._options.replicaReadingModeToggle.desktop) {
        this._isDoublePage =
          CookieManager.getCookie(
            CookieManager.cookieKeys.DESKTOP_DOUBLEPAGE
          ) === "true";
      } else {
        this._isDoublePage = this._options.replicaReadingModeDefault.desktop;
      }
    } else if (this.isTablet) {
      if (this._options.replicaReadingModeToggle.tablet)
        this._isDoublePage =
          CookieManager.getCookie(
            CookieManager.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY
          ) === "true";
      else this._isDoublePage = this._options.replicaReadingModeDefault.tablet;
    } else {
      this._isDoublePage = this._options.replicaReadingModeDefault.phone;
    }
    return this._isDoublePage;
  }

  set isDoublePage(isDoublePage) {
    if (isDoublePage !== this._isDoublePage) {
      this._isDoublePage = isDoublePage;
      if (!this.isDesktop) {
        CookieManager.createCookie(
          CookieManager.cookieKeys.DOUBLEPAGE_LANDSCAPEDISPLAY,
          this._isDoublePage
        );
      } else {
        CookieManager.createCookie(
          CookieManager.cookieKeys.DESKTOP_DOUBLEPAGE,
          this._isDoublePage
        );
      }

      this.trigger("appState:isDoublePageChanged", this._preferredViewer);
    }
  }

  set jumpToPageNumber(pageNumber) {
    this._jumpToPageNumber = pageNumber;

    if (pageNumber != null) {
      this.trigger("appState:jumpToPageChanged", pageNumber);
    }
  }

  set jumpToPageReference(pageNumber) {
    const pageRefererNumber = this._jumpToPageReference;
    this._jumpToPageReference = pageNumber;

    if (pageNumber === null) {
      this.trigger("appState:backToPageReferer", pageRefererNumber);
      this._jumpToPageNumber = null;
    }
  }

  set isFreePublication(isfreePub) {
    this._isFreePublication = isfreePub;
  }

  get isFreePublication() {
    return this._isFreePublication;
  }
}



// WEBPACK FOOTER //
// ./src/common/appState.js